import clsx from 'clsx'
import IntLink from 'components/common/IntLink'
import LoadingCircle from 'components/common/LoadingCircle'
import BasketIcon from 'components/icons/BasketIcon'
import useSlug from 'hooks/useSlug'
import formatMoney from 'lib/formatMoney'
import { isNonEmptyArray, isSamePath } from 'lib/utils'

import { useCallback } from 'react'
import { IGetCartResult, useGetUserCartQuery } from 'store/api'

let HeaderCart = () => {
  let { router, queryLng } = useSlug();
  const { data: userCart, isLoading: isLoadingUserCart } = useGetUserCartQuery(queryLng);

  const getCartTotal = (cart: IGetCartResult | undefined) => {
    if (!cart) return 0;

    if (isNonEmptyArray(cart.applied_coupons)) {
      return cart.items.reduce((acc, { price, quantity }) => acc + (price ?? 0) * quantity, 0);
    } else {
      return cart.products_sum;
    }

  }

  const cartTotal = getCartTotal(userCart?.data?.cart);
  const cartQty = userCart?.data?.cart ? userCart?.data?.cart.items.reduce((acc, { quantity }) => acc + quantity, 0) : 0;


  let handleOpen = useCallback(() => {
    void router.push('/cart', undefined, { shallow: true })
  }, [router])

  const colorSvg = !isSamePath(router.asPath, '/cart') ? '#FF6262' : '#fcb20a';

  return (
    <>
      <IntLink
        href='/cart'
        aria-label='Корзина'
        title='Корзина'
        className='lg:hidden  bg-[#F4F4F4] group bg-lightGrey rounded-full w-[33px] h-[33px] flex items-center justify-center'
      >
        <svg
          className={clsx('', { 'text-darkYellow': isSamePath(router.asPath, '/cart'), 'text-accent': !isSamePath(router.asPath, '/cart'), })}
          width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.375 5.24734V4.87219C6.375 3.42184 7.55074 2.24609 9.00109 2.24609V2.24609C10.4514 2.24609 11.6272 3.42184 11.6272 4.87219V5.24734" stroke={colorSvg} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.50016 8.25V9.00031" stroke={colorSvg} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M10.5002 8.25V9.00031" stroke={colorSvg} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M11.6272 11.7695C10.1225 13.0821 7.87972 13.0821 6.375 11.7695" stroke={colorSvg} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
          <path fillRule="evenodd" clipRule="evenodd" d="M4.84668 5.25C4.05428 5.25 3.39845 5.86615 3.34902 6.65702L3.00463 12.1674C2.94649 13.0976 3.27547 14.0105 3.91363 14.6898C4.55179 15.3691 5.44237 15.7544 6.37442 15.7544H11.6263C12.5584 15.7544 13.449 15.3691 14.0872 14.6898C14.7253 14.0105 15.0543 13.0976 14.9962 12.1674L14.6518 6.65702C14.6023 5.86615 13.9465 5.25 13.1541 5.25H4.84668Z" fill={colorSvg} stroke={colorSvg} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {/*
        <BasketIcon
          className={clsx('h-6 w-6', { 'text-darkYellow': isSamePath(router.asPath, '/cart'), 'text-accent': !isSamePath(router.asPath, '/cart'), })}
          aria-hidden='true'
        />
        */}

        {cartQty > 0 && (
          <div className=' absolute bottom-[-2.5px] right-[-1px] max-w-[18px] max-h-[18px] w-[18px] h-[18px] leading-[22px] text-accent bg-white rounded-full text-[10px] flex items-center justify-center font-bold  tracking-tight'>
            {cartQty}
          </div>
        )}
      </IntLink>

      <div className='hidden lg:flex relative items-center '>
        <button
          type='button'
          onClick={handleOpen}
          className=' group'
          aria-label='Корзина'
          title='Корзина'
        >
          <div className='flex gap-[10px] items-center'>
            <BasketIcon
              className={clsx('h-6 w-6 flex-shrink-0', {
                'text-darkYellow': isSamePath(router.asPath, '/cart'),
                'text-accent': !isSamePath(router.asPath, '/cart'),
              })}
              aria-hidden='true'
            />


            {isLoadingUserCart &&
              <div className='h-[20px]'>
                <LoadingCircle />
              </div>
            }

            {!isLoadingUserCart && cartQty > 0 &&
              <span className='hover:text-accent text-[15px] leading-[20px]  whitespace-nowrap'>
                {formatMoney(cartTotal)}
              </span>
            }

            {!isLoadingUserCart && cartQty === 0 &&
              <span className='hover:text-accent text-[15px] leading-[20px]  whitespace-nowrap'>
                Корзина пуста
              </span>
            }

          </div>
        </button>
      </div>
    </>
  )
}

export default HeaderCart
